import { AlarmOutput } from 'domain/alarm-output'
import { downloadCsv, buildCsvFilename } from 'shared/utils/csv-export'
import { getCriterionDisplayValue, getCriterionTypeLabel } from '../config/criterion-config'
import { getAlarmTypeLabel } from '../types/signal-r-alarm-type.helpers'

const CSV_HEADERS = [
  'Tipo',
  'Câmera',
  'Data/Hora',
  'Critérios',
  'URL Evidência',
]

const formatCriterias = (event: AlarmOutput): string =>
  event.criterias
    .map((c) => `${getCriterionTypeLabel(c.type, false)}: ${getCriterionDisplayValue(c.value)}`)
    .join('; ')

const formatRow = (event: AlarmOutput): (string | number)[] => {
  const date = new Date(event.detectedAt).toLocaleString('pt-BR')
  return [
    getAlarmTypeLabel(event.type),
    event.cameraName ?? '',
    date,
    formatCriterias(event),
    event.evidence ?? '',
  ]
}

export const exportAlarmEventsToCSV = (
  events: AlarmOutput[],
  filename?: string
): void => {
  downloadCsv(CSV_HEADERS, events.map(formatRow), filename ?? buildCsvFilename('eventos-alarme'))
}
